module.exports = __webpack_public_path__ + "static/media/logo_nyt.212a84b6.jpg";